import { useState, useCallback } from 'react';
import { fetchRandomQuote, getErrorMessage } from '../api/quotes';

const useQuote = () => {
    const [quote, setQuote] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchQuote = useCallback(async (category = '') => {
        setLoading(true);
        setError(null);
        try {
            const { quote: text, author } = await fetchRandomQuote(category);
            setQuote({ text, author });
        } catch (err) {
            setError(getErrorMessage(err));
        } finally {
            setLoading(false);
        }
    }, []);

    return { quote, loading, error, fetchQuote };
};

export default useQuote;
